(function () {
  'use strict';

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function extractCoords(mapEmbedUrl) {
    if (!mapEmbedUrl) return null;
    var latMatch = mapEmbedUrl.match(/!3d(-?\d+\.?\d*)/);
    var lngMatch = mapEmbedUrl.match(/!2d(-?\d+\.?\d*)/);
    if (!latMatch || !lngMatch) return null;
    var lat = parseFloat(latMatch[1]);
    var lng = parseFloat(lngMatch[1]);
    if (isNaN(lat) || isNaN(lng)) return null;
    return { latitude: lat, longitude: lng };
  }

  function normalizeTimePart(part) {
    return (part || '')
      .replace(/\u202f/g, ' ')
      .replace(/[–—]/g, '-')
      .trim()
      .toLowerCase();
  }

  function parseTimeToMinutes(part) {
    var text = normalizeTimePart(part);
    if (!text || text === 'closed') return null;
    var match = text.match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?$/i);
    if (!match) return null;
    var hours = parseInt(match[1], 10);
    var minutes = parseInt(match[2] || '0', 10);
    var meridiem = (match[3] || '').toLowerCase();
    if (meridiem === 'pm' && hours < 12) hours += 12;
    if (meridiem === 'am' && hours === 12) hours = 0;
    if (!meridiem && hours >= 1 && hours <= 7) hours += 12;
    return hours * 60 + minutes;
  }

  function formatTime12(part) {
    var minutes = parseTimeToMinutes(part);
    if (minutes == null) return '';
    var hours24 = Math.floor(minutes / 60);
    var mins = minutes % 60;
    var meridiem = hours24 >= 12 ? 'PM' : 'AM';
    var hours12 = hours24 % 12 || 12;
    return hours12 + ':' + String(mins).padStart(2, '0') + ' ' + meridiem;
  }

  function getTodayHours(hoursObj) {
    if (!hoursObj || typeof hoursObj !== 'object') return null;
    var todayName = DAY_NAMES[new Date().getDay()];
    var raw = hoursObj[todayName];
    if (!raw || /closed/i.test(raw)) return { isOpen: false };
    var parts = raw.replace(/\u202f/g, ' ').split(/\s*[–—-]\s*/);
    if (parts.length < 2) return null;
    var openMinutes = parseTimeToMinutes(parts[0]);
    var closeMinutes = parseTimeToMinutes(parts[1]);
    if (openMinutes == null || closeMinutes == null) return null;
    var nowMinutes = new Date().getHours() * 60 + new Date().getMinutes();
    return {
      isOpen: nowMinutes >= openMinutes && nowMinutes < closeMinutes,
      closeTime: formatTime12(parts[1]),
    };
  }

  function parseLocationParts(name, address) {
    var city = '';
    var state = '';
    var zip = '';
    var source = (name || '') + ' ' + (address || '');
    var stateZipMatch = source.match(/\b([A-Za-z .'-]+),\s*([A-Z]{2})\s+(\d{5}(?:-\d{4})?)\b/);
    if (stateZipMatch) {
      city = stateZipMatch[1].trim();
      state = stateZipMatch[2];
      zip = stateZipMatch[3];
      return { city: city, state: state, zip: zip };
    }
    var tailMatch = source.match(/\b([A-Za-z .'-]+)\s+([A-Z]{2})\s*$/);
    if (tailMatch) {
      city = tailMatch[1].trim();
      state = tailMatch[2];
    }
    return { city: city, state: state, zip: zip };
  }

  function transformStore(id, raw) {
    if (!raw || !id) return null;
    var coords = extractCoords(raw.map_embed_url);
    if (!coords) return null;

    var location = parseLocationParts(raw.name, raw.address);
    var shopUrl = raw.collection_url || '';
    var detailUrl = raw.detail_url || (shopUrl ? shopUrl.replace(/\/collections\//, '/pages/') : '/pages/' + id);

    return {
      id: id,
      name: raw.name || raw.brand || 'Store',
      name2: raw.name || raw.brand || 'Store',
      brand: raw.brand || 'EZPAWN',
      address: raw.address || '',
      city: raw.city || location.city || '',
      state: raw.state || location.state || '',
      zip: raw.zip || location.zip || '',
      phone: raw.phone || '',
      latitude: coords.latitude,
      longitude: coords.longitude,
      todayHours: getTodayHours(raw.hours),
      services: Array.isArray(raw.services) ? raw.services : ['Buy Online Pick Up In Store'],
      shop_url: shopUrl,
      url: detailUrl,
    };
  }

  function transform(storesData) {
    if (!storesData || typeof storesData !== 'object') return [];
    return Object.keys(storesData)
      .map(function (id) {
        return transformStore(id, storesData[id]);
      })
      .filter(Boolean);
  }

  window.EzStoresMapData = {
    transform: transform,
    extractCoords: extractCoords,
    getTodayHours: getTodayHours,
    parseLocationParts: parseLocationParts,
  };
})();
